import React from 'react';
import CardUI from '../../../widgets/layout/CardUI';
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI';
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI';
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI';
import BadgeUI from '../../../widgets/output/BadgeUI';

// The MessageApprovalListUI component
const MessageApprovalListUI = ({ context, messages, onUpdateMessageClick }) => (
  <div>
    {
      messages.map((message, i) => (
        <LRTableBodyUI key={i}>
          <CardUI>
            <div className='g_flex_h g_flex_top g_flex_left'>
              <LabelAndValueUI label='Email Recipients'>
                {
                  message.emailToList.map((email, j) =>
                    <span key={j} className='g_flex_v'>{email}</span>
                  )}
              </LabelAndValueUI>
              <span className='g_m_right_100' />
              <span className='g_m_right_100' />
              <LabelAndValueUI label='File Attachments'>
                {
                  message.fileUploadList.map((file, j) =>
                    <span key={j}>{file}</span>
                  )}
              </LabelAndValueUI>
            </div>
          </CardUI>
          <LRTableRowUI className='g_flex_top'
            left={<RowLeftUI message={message} />}
            right={<RowRightUI message={message} onUpdateMessageClick={onUpdateMessageClick} />}
          />
        </LRTableBodyUI>
      ))
    }
  </div>
);

// RowLeftUI component to display message details
const RowLeftUI = ({ message }) => (
  <div>
    Subject: {message.emailSubject}<br />
    <span dangerouslySetInnerHTML={{ __html: message.message }} />
  </div>
);


const RowRightUI = ({ message, onUpdateMessageClick }) => (
  <div className='g_flex_h'>
    {/* Edit (pencil) icon */}
    {
      message.pendingStatus &&
      <BadgeUI label={message.pendingStatus} />
    }
    {/* <span
      className='icon icon-pencil g_m_left_50'
      onClick={onUpdateMessageClick}
      message-approval-id={message.messageApprovalId}
    /> */}
  </div>
);
export default MessageApprovalListUI;
